/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_New_Princes_HintInputs */



/**
* | output |
* | --- |
* | "For a national league, you can add the country's Princes as organizers after creation." |
*
* @param {League_New_Princes_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_new_princes_hint = /** @type {((inputs?: League_New_Princes_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_New_Princes_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pour une ligue nationale, vous pouvez ajouter les Princes du pays comme organisateurs après la création.")
	if (locale === "es") return /** @type {LocalizedString} */ ("En una liga nacional, puede añadir a los Princes del país como organizadores tras crearla.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Numa liga nacional, você pode adicionar os Princes do país como organizadores depois de criá-la.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per un campionato nazionale, puoi aggiungere i Princes del paese come organizzatori dopo la creazione.")
	return /** @type {LocalizedString} */ ("For a national league, you can add the country's Princes as organizers after creation.")
});